import standard  from '../../assets/images/chapeaux/1 Standard.jpg'
import classique  from '../../assets/images/chapeaux/2 Classique.jpg'
import elegant  from '../../assets/images/chapeaux/3 Élégant.jpg'
import moderne  from '../../assets/images/chapeaux/4 Moderne.jpg'
import euro  from '../../assets/images/chapeaux/5 Euro.jpg'
import rustique  from '../../assets/images/chapeaux/6 Rustique.jpg'
import urbainLeger  from '../../assets/images/chapeaux/7 Urbain Léger.png'
import urbain  from '../../assets/images/chapeaux/8 urbain.png'
import contemporain  from '../../assets/images/chapeaux/9 Contemporain.jpg'
import champetre from '../../assets/images/chapeaux/Champêtre 1.jpg'
import montRoyalEuroStandard from '../../assets/images/chapeaux/Mont-Royale Euro Standard 6.jpg'
import montRoyalEuroClassique from '../../assets/images/chapeaux/11 Mont-Royal Euro Classique.jpg'
// import montRoyalEuroElegant from '../../assets/images/chapeaux/'
import montRoyalRustiqueStandard from '../images/chapeaux/13 Mont-Royal Rustique Standard.png'
import montRoyalRustiqueClassique from '../../assets/images/chapeaux/14 Mont-Royal Rustique Classique.jpg'
import montRoyalRustiqueElegant from '../../assets/images/chapeaux/Mont-Royale Rustique Élégant 1.jpg'





export const chapeaux = [
    {
        id: 0,
        model: 'le Standard',
        src: standard,
        description: "Notre modèle Standard est proposé à un prix compétitif et convient à la plupart des installations de cheminée."
    },
    {
        id: 1,
        model: 'le Classique',
        src: classique,
        description: "Le modèle Classique est un choix parfait pour ceux qui cherchent à ajouter du style et de l'élégance à leur cheminée, sans compromettre leur budget."
    },
    {
        id: 2,
        model: "l'Élégant",
        src: elegant,
        description: "Si vous cherchez à ajouter une touche de style et d'élégance à votre cheminée, le chapeau Élégant est un excellent choix."
    },
    {
        id: 3,
        model: 'le Moderne',
        src: moderne,
        description: "Cette cheminée a été spécialement conçue pour s'adapter aux styles de construction contemporains du 21ème siècle"
    },
    {
        id: 4,
        model: "l'Euro",
        src: euro,
        description: "Le modèle Euro est un véritable hommage à l'Europe traditionnelle, ajoutant une touche de charme à l'ancienne à tous les styles de maison et de revêtements."
    },
    {
        id: 5,
        model: 'le Rustique',
        src: rustique,
        description: "Le style rustique revient en force ! Et pour retrouver l'apparence authentique d'un toit en tôle pincée d'antan, rien de mieux que le modèle Rustique."
    },
    {
        id: 6,
        model: "l'Urbain léger",
        src: urbainLeger,
        description: "L'allure moderne du modèle urbain dans une version allégée"
    },
    {
        id: 7,
        model: "l'Urbain",
        src: urbain,
        description: "Alliant discrétion et efficacité, le modèle Urbain s’intègre parfaitement dans les environnements citadins."
    },
    {
        id: 8,
        model: 'le Contemporain',
        src: contemporain,
        description: "Le design contemporain de ce modèle s'adapte parfaitement aux maisons d'architecture unique et moderne."
    },
    {
        id: 9,
        model: 'le Champêtre',
        src: champetre,
        description: "Avec ses lignes douces et son allure traditionnelle, il s’intègre naturellement dans les paysages ruraux et les habitations au cachet authentique."
    },
     {
        id: 10,
        model: 'le Mont-royal euro base standard',
        src: montRoyalEuroStandard ,
        description: "le chapeau parfait pour les cheminées de maçonnerie sur une base standard."
    },
    {
        id: 11,
        model: 'le Mont-royal euro base classique',
        src: montRoyalEuroClassique,
        description: "Le chapeau parfait pour les cheminées de maçonnerie sur une base classique ."
    },
    // {
    //     id: 12,
    //     model: 'Mont-royal euro base elegant',
    //     src: 
    //     description: ""
    // },
    {
        id: 13,
        model: 'le Mont-royal rustique base standard',
        src: montRoyalRustiqueStandard,
        description: "Le chapeau parfait pour les cheminées de maçonnerie dans un style rustique sur une base standard."
    },
    {
        id: 14,
        model: 'le Mont-Royal rustique base classique',
        src: montRoyalRustiqueClassique,
        description: "Le chapeau parfait pour les cheminées de maçonnerie sur une base classique."
    },
    {
        id: 15,
        model: 'le Mont-royal rustique base élegante',
        src: montRoyalRustiqueElegant,
        description: "Le chapeau parfait pour les cheminées de maçonnerie sur une base plus élegante."
    },
]